<template>
	<svg
		v-if="symbolId && name !== 'mono/load'"
		:class="{'cursor-pointer': isClickable}"
		class="base-icon"
		aria-hidden="true"
		@click="$emit('click', $event)"
	>
		<use :href="symbolId" />
	</svg>
	<!-- This is an inline copy of former `mono/load.svg`, because the sprite doesn't anmiate; this is not just due to SVGO removing the animation by default (can be fixed by disabling the `removeMatchedOnce` default plugin in `vite-plugin-create-svg-sprite.js`), but seemingly becaues external SVG sprites aren't really animated when imported using `<use/>` -->
	<svg
		v-else-if="name === 'mono/load'"
		class="base-icon"
		aria-hidden="true"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		viewBox="0 0 100 100"
		preserveAspectRatio="xMidYMid"
	>
		<g transform="translate(90,50)">
			<g transform="rotate(0)">
				<circle cx="0" cy="0" r="10" fill="currentColor" fill-opacity="1" transform="scale(1 1)">
					<animateTransform
						attributeName="transform"
						type="scale"
						begin="-0.875s"
						values="1 1;1 1"
						keyTimes="0;1"
						dur="1s"
						repeatCount="indefinite"
					></animateTransform>
					<animate
						attributeName="fill-opacity"
						keyTimes="0;1"
						dur="1s"
						repeatCount="indefinite"
						values="1;0"
						begin="-0.875s"
					></animate>
				</circle>
			</g>
		</g>
		<g transform="translate(78.2842712474619,78.2842712474619)">
			<g transform="rotate(45)">
				<circle cx="0" cy="0" r="10" fill="currentColor" fill-opacity="0.875" transform="scale(1 1)">
					<animateTransform
						attributeName="transform"
						type="scale"
						begin="-0.75s"
						values="1 1;1 1"
						keyTimes="0;1"
						dur="1s"
						repeatCount="indefinite"
					></animateTransform>
					<animate
						attributeName="fill-opacity"
						keyTimes="0;1"
						dur="1s"
						repeatCount="indefinite"
						values="1;0"
						begin="-0.75s"
					></animate>
				</circle>
			</g>
		</g>
		<g transform="translate(50,90)">
			<g transform="rotate(90)">
				<circle cx="0" cy="0" r="10" fill="currentColor" fill-opacity="0.75" transform="scale(1 1)">
					<animateTransform
						attributeName="transform"
						type="scale"
						begin="-0.625s"
						values="1 1;1 1"
						keyTimes="0;1"
						dur="1s"
						repeatCount="indefinite"
					></animateTransform>
					<animate
						attributeName="fill-opacity"
						keyTimes="0;1"
						dur="1s"
						repeatCount="indefinite"
						values="1;0"
						begin="-0.625s"
					></animate>
				</circle>
			</g>
		</g>
		<g transform="translate(21.7157287525381,78.2842712474619)">
			<g transform="rotate(135)">
				<circle cx="0" cy="0" r="10" fill="currentColor" fill-opacity="0.625" transform="scale(1 1)">
					<animateTransform
						attributeName="transform"
						type="scale"
						begin="-0.5s"
						values="1 1;1 1"
						keyTimes="0;1"
						dur="1s"
						repeatCount="indefinite"
					></animateTransform>
					<animate
						attributeName="fill-opacity"
						keyTimes="0;1"
						dur="1s"
						repeatCount="indefinite"
						values="1;0"
						begin="-0.5s"
					></animate>
				</circle>
			</g>
		</g>
		<g transform="translate(10,50.00000000000001)">
			<g transform="rotate(180)">
				<circle cx="0" cy="0" r="10" fill="currentColor" fill-opacity="0.5" transform="scale(1 1)">
					<animateTransform
						attributeName="transform"
						type="scale"
						begin="-0.375s"
						values="1 1;1 1"
						keyTimes="0;1"
						dur="1s"
						repeatCount="indefinite"
					></animateTransform>
					<animate
						attributeName="fill-opacity"
						keyTimes="0;1"
						dur="1s"
						repeatCount="indefinite"
						values="1;0"
						begin="-0.375s"
					></animate>
				</circle>
			</g>
		</g>
		<g transform="translate(21.71572875253809,21.7157287525381)">
			<g transform="rotate(225)">
				<circle cx="0" cy="0" r="10" fill="currentColor" fill-opacity="0.375" transform="scale(1 1)">
					<animateTransform
						attributeName="transform"
						type="scale"
						begin="-0.25s"
						values="1 1;1 1"
						keyTimes="0;1"
						dur="1s"
						repeatCount="indefinite"
					></animateTransform>
					<animate
						attributeName="fill-opacity"
						keyTimes="0;1"
						dur="1s"
						repeatCount="indefinite"
						values="1;0"
						begin="-0.25s"
					></animate>
				</circle>
			</g>
		</g>
		<g transform="translate(49.99999999999999,10)">
			<g transform="rotate(270)">
				<circle cx="0" cy="0" r="10" fill="currentColor" fill-opacity="0.25" transform="scale(1 1)">
					<animateTransform
						attributeName="transform"
						type="scale"
						begin="-0.125s"
						values="1 1;1 1"
						keyTimes="0;1"
						dur="1s"
						repeatCount="indefinite"
					></animateTransform>
					<animate
						attributeName="fill-opacity"
						keyTimes="0;1"
						dur="1s"
						repeatCount="indefinite"
						values="1;0"
						begin="-0.125s"
					></animate>
				</circle>
			</g>
		</g>
		<g transform="translate(78.2842712474619,21.71572875253809)">
			<g transform="rotate(315)">
				<circle cx="0" cy="0" r="10" fill="currentColor" fill-opacity="0.125" transform="scale(1 1)">
					<animateTransform
						attributeName="transform"
						type="scale"
						begin="0s"
						values="1 1;1 1"
						keyTimes="0;1"
						dur="1s"
						repeatCount="indefinite"
					></animateTransform>
					<animate
						attributeName="fill-opacity"
						keyTimes="0;1"
						dur="1s"
						repeatCount="indefinite"
						values="1;0"
						begin="0s"
					></animate>
				</circle>
			</g>
		</g>
	</svg>
</template>

<script>
import {defineComponent} from 'vue'

export default defineComponent({
	name: 'BaseIcon',
	props: {
		name: {
			type: String,
			required: true,
		},
	},
	emits: ['click'],
	computed: {
		symbolId() {
			if (!this.name) return
			if (import.meta.env.VUE_APP_TARGET === 'extension') {
				return '/icons/sprite.svg#' + this.name.replace('/', '--')
			}
			return '/static/img/icons/sprite.svg#' + this.name.replace('/', '--')
		},
		isClickable() {
			return this.$attrs && this.$attrs.onClick
		},
	},
})
</script>

<style scoped>
.base-icon {
	display: inline-block;
	flex: none;
	height: 14px;
	width: 14px;
	fill: currentColor;
}
</style>
